import React from 'react';
import PropTypes from 'prop-types';
import PasswordResetFormContainer from './PasswordResetFormContainer';

const propTypes = {
  location: PropTypes.object.isRequired,
};

const PasswordResetPage = ({ location }) => (
  <div className="container no-sidebar">
    <div className="row">
      <div className="col-md-6 col-md-offset-3">
        <div className="card card-block">
          <h2 className="card-title">Reset Password</h2>
          <h5 className="card-text">Please reset your password below. </h5>
          <p>
            <i>
              {' '}
              Note: Passwords must contain at least one uppercase letter, one lowercase letter, and
              one number.
            </i>
          </p>
          <PasswordResetFormContainer securityToken={location.query.auth} />
        </div>
      </div>
    </div>
  </div>
);

PasswordResetPage.propTypes = propTypes;

export default PasswordResetPage;
